import { render, staticRenderFns } from "./Datalist.vue?vue&type=template&id=351f8fb5&scoped=true"
import script from "./Datalist.vue?vue&type=script&lang=js"
export * from "./Datalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f8fb5",
  null
  
)

export default component.exports